import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

const matchParticipantsUrl = (path: string) => {
  const opts: QueryUrlOptions = {
    identifier: { type: 'match-participants' },
    op: 'query',
    resourcePath: 'match-participants',
  };
  return `${buildBaseURL(opts)}/${path.replace(/^\/+/, '')}`;
};

/** PATCH /match-participants/:id/begin-enrollment */
export function beginEnrollmentRequest(id: string): RequestInfo {
  return {
    url: matchParticipantsUrl(`${id}/begin-enrollment`),
    method: 'PATCH',
    cacheOptions: { [SkipCache]: true },
  };
}

/** PATCH /match-participants/:id/attempt-complete-enrollment */
export function activateMatchParticipantRequest(id: string): RequestInfo {
  return {
    url: matchParticipantsUrl(`${id}/attempt-complete-enrollment`),
    method: 'PATCH',
    cacheOptions: { [SkipCache]: true },
  };
}

/** GET /match-participants/:id/insights */
export function getMatchParticipantInsightsRequest(id: string): RequestInfo {
  return {
    url: matchParticipantsUrl(`${id}/insights`),
    method: 'GET',
    cacheOptions: { [SkipCache]: true },
  };
}
